import React from "react";
import LegalLayout from "./LegalLayout";

export default function Cookies() {
  return (
    <LegalLayout title="Cookie & Analytics Notice" effectiveDate="February 1, 2026">
      <p>Home Cost Path uses a small number of cookies and one product-analytics service. This notice explains what each one does.</p>

      <h2>Strictly necessary cookies</h2>
      <ul>
        <li><b>access_token</b> — an authentication token set after you log in. HttpOnly, Secure, SameSite=None. Required for the app to know you're signed in.</li>
        <li><b>session_token</b> — set for Google-OAuth sessions issued via Emergent-managed OAuth. Same HttpOnly / Secure attributes.</li>
      </ul>
      <p>You cannot use Home Cost Path while signed in without these cookies.</p>

      <h2>Local storage (browser only, not sent to a server)</h2>
      <ul>
        <li><b>hs_worksheet_v1</b> — your unsaved worksheet, so it survives navigation and returning to the site.</li>
        <li><b>hs_seen_intro</b> — remembers you've seen the wizard intro.</li>
        <li><b>ctk_sample_nudge_v1</b> — remembers you've dismissed the sample-VA onboarding modal.</li>
      </ul>

      <h2>Product analytics — PostHog</h2>
      <p>We use PostHog to count how often key product events happen. This helps us prioritize what to improve. Session replay is <b>disabled</b>. Text-input auto-capture is <b>disabled</b>. We forward only a small allowlist of event names and coarse, non-sensitive properties:</p>
      <ul>
        <li><b>landing_view</b> — landing page loaded (no properties)</li>
        <li><b>analysis_started</b> — user progressed past the financing-type step (<code>financing_type</code>: "va" | "fha" | "conventional" | "usda" | "not_sure")</li>
        <li><b>analysis_completed</b> — Results page loaded (<code>financing_type</code>)</li>
        <li><b>account_created</b> — email/password signup completed (no properties)</li>
        <li><b>home_saved</b> — user saved a home (<code>financing_type</code>)</li>
        <li><b>paywall_view</b> — upgrade page opened (<code>reason</code> code such as "pdf_export"; <code>plan_type</code>)</li>
        <li><b>checkout_started</b> — user was redirected to Stripe Checkout (no properties)</li>
        <li><b>checkout_completed</b> — Stripe confirmed payment (<code>plan_type</code>: "premium")</li>
        <li><b>report_shared</b> — user generated a shareable link (no properties)</li>
      </ul>
      <p>We do <b>not</b> send purchase prices, income, debts, cash amounts, ZIP codes, addresses, credit-score ranges, seller credits, or any other financial worksheet values to PostHog. Users are identified in PostHog only by an opaque, non-reversible user id. See PostHog's <a href="https://posthog.com/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a> for more.</p>

      <h2>How to opt out</h2>
      <p>You can block analytics by using your browser's tracking-protection features or a content-blocking extension. Doing so will not affect your ability to use the calculator, save homes, or purchase the Home Buying Pass.</p>

      <h2>Contact</h2>
      <p><a href="mailto:support@homecostpath.com">support@homecostpath.com</a></p>
    </LegalLayout>
  );
}
